import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { locationByLatLngQuery } from '../utils/queries';
export function getLocDataByLatLng() {
  return _getLocDataByLatLng.apply(this, arguments);
}
function _getLocDataByLatLng() {
  _getLocDataByLatLng = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
    var _ref,
      lat,
      lng,
      graphqlClient,
      zip,
      res,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, lat = _ref.lat, lng = _ref.lng;
          graphqlClient = _args2.length > 1 ? _args2[1] : undefined;
          zip = '';
          if (!(lat && lng)) {
            _context2.next = 15;
            break;
          }
          _context2.prev = 4;
          _context2.next = 7;
          return graphqlClient.query({
            query: locationByLatLngQuery,
            variables: {
              latitude: lat,
              longitude: lng
            },
            ssr: true
          });
        case 7:
          res = _context2.sent;
          zip = res.data.locationInfoByLatLng;
          if (!zip.isValid) {
            zip = null;
          }
          _context2.next = 15;
          break;
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](4);
          console.log(_context2.t0);
        case 15:
          return _context2.abrupt("return", zip);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 12]]);
  }));
  return _getLocDataByLatLng.apply(this, arguments);
}
;
var getCurrentPosition = function getCurrentPosition() {
  return new Promise(function (resolve, reject) {
    window.navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};
export function getGeolocationLatLng() {
  return _getGeolocationLatLng.apply(this, arguments);
}
function _getGeolocationLatLng() {
  _getGeolocationLatLng = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
    var pos, lat, lng;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(typeof window === 'undefined')) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", null);
        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return getCurrentPosition();
        case 5:
          pos = _context3.sent;
          lat = pos.coords.latitude;
          lng = pos.coords.longitude;
          return _context3.abrupt("return", {
            lat: lat,
            lng: lng
          });
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          console.log(_context3.t0);
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 11]]);
  }));
  return _getGeolocationLatLng.apply(this, arguments);
}
;
export var getGeoLocation = function () {
  var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(client) {
    var latlng;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getGeolocationLatLng();
        case 2:
          latlng = _context.sent;
          if (!latlng) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", getLocDataByLatLng(latlng, client));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getGeoLocation(_x) {
    return _ref2.apply(this, arguments);
  };
}();